module.exports = __webpack_public_path__ + "static/img/case_3.afb9a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_3.jpg
// module id = ydWI
// module chunks = 0